<template>
  <div class="change-password-page">
    <div class="module">
      <!-- <div class="title">修改密码</div> -->
      <div class="content">
        <div style="margin-top: 10px; padding: 0 10px">
          <div style="text-align: left">
            <p style="line-height: 20px">
              为了安全起见，您必须每30天改变一次密码。
            </p>
            <p style="margin-bottom: 10px; line-height: 20px">
              您的密码必须根据以下规则:
            </p>
            <p style="line-height: 20px">
              1.至少要有两个大或小写英文字母和数字(0-9)组合,字数最少6至12个。
            </p>
            <p style="line-height: 20px">2.三个不同的字母数字。</p>
            <p style="line-height: 20px">3.不准许有空格。</p>
          </div>
        </div>
        <div class="form">
          <div class="row">
            <!-- <span>原密码</span> -->
            <input
              class="input left"
              type="password"
              autocomplete="new-password"
              v-model="password"
              placeholder="当前密码"
            />
          </div>
          <div class="row">
            <!-- <span>新密码</span> -->
            <input
              class="input left"
              type="password"
              autocomplete="new-password"
              v-model="newpwd"
              placeholder="新密码"
            />
          </div>
          <div class="row">
            <!-- <span>确认密码</span> -->
            <input
              class="input left"
              type="password"
              autocomplete="new-password"
              v-model="newpwd2"
              placeholder="确定密码"
            />
          </div>
          <!-- <div class="tips">
            系统提示：密码必须包含大写字母、小写字母、数字长度大于6位！
          </div> -->
          <div class="login-btn">
            <input class="reset" type="submit" @click="reset" value="重置" />
            <input class="submit" type="submit" @click="sure" value="确定" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: null,
      password: "",
      newpwd: "",
      newpwd2: "",
    };
  },
  props: ["initFinished", "userInfo"],
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getUserInfo();
    },
    async getUserInfo() {
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let data = {
        access_token,
        uid,
      };
      let result = await this.$http.postAxiosMethod("/user/userinfo", data);
      if (result.code == 0) {
        this.userInfo = result.data;
        sessionStorage.setItem("isplayer", result.data.isplayer);
        this.$store.state.user = result.data;
        this.$store.state.userInfo = Object.assign(
          this.$store.state.userInfo,
          result.data
        );
      }
    },
    async sure() {
      if (this.newpwd !== this.newpwd2 || !this.password) {
        document.activeElement.blur();
        this.$alert("请输入密码或者新密码两次输入不一致", "提示");
        return;
      }
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        username: this.userInfo.username,
        password: this.password,
        newpwd: this.newpwd,
      };
      let result = await this.$http.postAxiosMethod("/user/newpwd", data);
      if (result.code == 0) {
        document.activeElement.blur();
        this.$alert("密码修改成功,请重新登录!", "提示");
        sessionStorage.clear();
        location.href = "/";
      }
    },
    reset() {
      this.password = "";
      this.newpwd = "";
      this.newpwd2 = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.change-password-page {
  background: var(--new-bg-white);
  > .module {
    display: flex;
    justify-content: center;
    > .content {
      > div {
        width: 100%;
        text-align: left;
      }
    }
  }
  .form {
    // transform: translateX(100px);
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 295px;
    font-size: 13px;
    .row {
      margin-bottom: 15px;
      & > span {
        margin-right: 15px;
        display: inline-block;
        width: 60px;
        text-align: right;
        font-weight: bold;
        color: var(--new-text-color);
      }
      input {
        width: 580px;
        height: 40px;
        // border: 1px solid #bad4e8;
        font-size: 14px;
      }
    }
    .tips {
      font-size: 12px;
      font-weight: 400;
      color: #ea0000;
    }
    .login-btn {
      margin-top: 15px;
      input {
        width: 280px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        cursor: pointer;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
      .reset {
        color: var(--new-text-active);
        background: var(--new-bg-table-header-main);
      }
      .submit {
        color: var(--new-text-primary-bg);
        background: var(--new-bg-primary);
      }
    }
  }
}
</style>
